import { Component, ElementRef, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from '@environment';
import { FormService } from '@services/form.service';
import { GlobalService } from '@services/global.service';
import { DataQueryDetail } from '@models/data-query-detail';
import { DataQueryOutputColumn, DataQueryOutputRow, DataQueryResult } from '@models/data-query-result';
import { DataQueryResultRow } from '@models/data-query-result-row';
import { FileService } from '@services/file.service';
import { Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { SharedService } from '@services/shared.service';
import { DataQueryResultsBaseComponent } from '../data-query-results-base/data-query-results-base.component';

class ResultRow {
    label: string;
    value: string;
    alignment: string;
    specialType: string;
    imageWidth: number;
    imageHeight: number;
    name: string;
    width: number;

    linkTarget: string;
    destinationRoute: string;
    destinationRouteParams: any;
}

class LinkTarget {
    route: string;
    params: any;
    streamType: string;
}

@Component({
    selector: 'cp-data-query-results-list',
    templateUrl: './data-query-results-list.component.html',
    styleUrls: ['./data-query-results-list.component.less'],
    standalone: false
})
export class DataQueryResultsListComponent extends DataQueryResultsBaseComponent  {
    columns: DataQueryOutputColumn[] = [];
    showNoResultsMessage: boolean;
    noResultsText: string;

    imageLocation: string = environment.ImageLocation;
    localImageLocation: string = environment.LocalImageLocation;

    languageCode: string;
    listType: string;
    headers: any[] = [];

    constructor(
        private globalService: GlobalService,
        private elementRef: ElementRef,
        private formService: FormService,
        private renderer: Renderer2,
        public sanitizer: DomSanitizer,
        private fileService: FileService,
        private router: Router,
        private userService: UserService,
        private pageService: PageService,
        private sharedService: SharedService,
    ) {
        super(globalService, formService, elementRef, renderer, router, pageService, sharedService, userService, fileService, sanitizer);
    }

    async processResultSet(resultSet: DataQueryResult): Promise<void> {
        // this.languageCode = this._globalService.getLanguageCode();
        this.listType = resultSet.ListType;

        let columnCount: number = 0;
        if (resultSet.QueryResults.length > 0) {
            columnCount = resultSet.QueryResults[0].FieldValues.length;
        }

        this.showNoResultsMessage = resultSet.ShowNoResultsMessage;
        this.noResultsText = resultSet.NoResultsText;

        // const row = new DataQueryOutputRow();
        this.columns = [];

        for (let i = 0; i < columnCount; ++i) {
            this.headers.push({
                text: resultSet.Details[i].Title,
                alignment: resultSet.Details[i].Alignment,
                width: resultSet.Details[i].Width
            });

            const data: DataQueryResultRow = resultSet.QueryResults[0];

            let column: DataQueryOutputColumn | null = this.formatColumn(resultSet, i, data);
            if (column) {
                this.columns.push(column);
            }
        }
    }

    async getFilestreamExists(fileName: string, streamType: string): Promise<boolean> {
        // var fileType = "customerportal";

        // let availability: boolean = await this._formService.getFilestreamExists(fileName, fileType, streamType);
        // return availability;
        return true;
    }

    override executeDataQuery(dq: string, idx: number): void {
        if (!dq || dq === "") {
            return; // invalid dataquery
        }

        let invalidInput: boolean = false;
        this.columns.forEach((column: DataQueryOutputColumn) => {
            if (column.name && column.name !== "") {
                const field = this.elementRef.nativeElement.querySelector(`#${column.name}_${idx}`);
                if (field) {
                    if (field.required && field.value === "") {
                        invalidInput = true;
                        this.renderer.setStyle(field, "border-color", "red");
                        this.renderer.setStyle(field, "border-style", "solid");
                        return;
                    }
                    this.renderer.setStyle(field, "border-color", "");
                    this.renderer.setStyle(field, "border-style", "");


                    dq = dq.replace("!" + column.name + "!", field.value);
                }
            }
        });

        if (!invalidInput) {
            this._formService.executeDataQuery(dq, {}).subscribe({
                next: () => this.refreshPage.emit(true)
            });
        }
    }
}
